/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capture_DismissingInputs */

const en_capture_dismissing = /** @type {(inputs: Capture_DismissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismissing…`)
};

const he_capture_dismissing = /** @type {(inputs: Capture_DismissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתעלם…`)
};

/**
* | output |
* | --- |
* | "Dismissing…" |
*
* @param {Capture_DismissingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const capture_dismissing = /** @type {((inputs?: Capture_DismissingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capture_DismissingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capture_dismissing(inputs)
	return he_capture_dismissing(inputs)
});